import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DOCUMENTATION_REPOSITORY } from '../domain/repositories/documentation.repository';
import { DocumentationRemoteDatasource } from './datasources/remote/documentation.remote-datasource';
import { DocumentationMapper } from './mappers/documentation.mapper';
import { DocumentationRepositoryImpl } from './repositories/documentation.repository.impl';

export function provideDocumentationData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DocumentationRemoteDatasource,
    DocumentationMapper,
    { provide: DOCUMENTATION_REPOSITORY, useClass: DocumentationRepositoryImpl },
  ]);
}
